import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledError = styled.p`
  color: red;
  margin-bottom: 0;
`;

const Error = ({ text }) => <StyledError>{text}</StyledError>;

Error.propTypes = {
  text: PropTypes.string.isRequired
};

export default Error;
